<template>
  <div
    v-if="exExperience.can_open_date"
    class="wrapper-availability-banner__custom"
  >
    <LadContainerMediaText>
      <p slot="title" class="container-with-icon">
        <span class="percentage-icon"><i class="fas fa-percentage"></i></span>
        <span
          class="percentage-text"
          v-html="$t(`${base}.banner.title`, { amount })"
        />
      </p>

      <div slot="description" class="description">
        <slot name="description">
          <p class="availability-banner--description">{{
            $t(`${base}.banner.description`)
          }}</p>
        </slot>

        <el-button
          v-if="isFlairAirlinesSource"
          type="success"
          class="reserve-with-cta"
          @click="scrollTo"
          >{{ $t(`${base}.banner.cta`) }}</el-button
        >

        <el-button
          v-else
          type="success"
          class="reserve-with-cta"
          @click="goToFastCheckout"
          >{{ $t(`${base}.banner.cta`) }}</el-button
        >
      </div>

      <div slot="image" class="container-image-cover">
        <LadCoverImage
          :max-width="400"
          :min-height="400"
          :include-all-sources="true"
          :lazy-loading="false"
          :preloading="true"
        />
      </div>
    </LadContainerMediaText>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LadPriceCommonMixin from '@/components/frontends/Price/components/mixin/promo'
import LadParamsMixin from '@/utils/mixin/lad-params'

export default {
  name: 'LadAvailabilityCustomBanner',
  components: {
    LadContainerMediaText: () =>
      import(
        /* webpackChunkName: "lad-container-media-text" */ '@/components/container-media-text/index'
      ),
    LadCoverImage: () =>
      import(
        /* webpackChunkName: "lad-cover-image" */ '@/components/cover/image'
      ),
  },
  mixins: [LadPriceCommonMixin, LadParamsMixin],
  props: {
    svg: { type: String, default: 'experience/layaway-campain' },
  },
  data() {
    return {
      base: 'experience.availability.custom',
    }
  },
  computed: {
    ...mapState('experience', {
      layawayAmount: (state) => state.sales_plan.layaway_amount,
      price: (state) => state.sales_plan.total_amount, // se usa en el mixin
      season: (state) => state.sales_plan.season,
      language: (state) => state.sales_plan.language,
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        name: state.experience.name,
        type: state.experience.type,
        duration: state.experience.duration,
        starting_point: state.experience.starting_point,
        ending_point: state.experience.ending_point,
        permalink: state.experience.permalink.default,
        country: state.experience.country,
        can_open_date: state.experience.can_open_date,
      }),
      hasPromotions: (state) => state.promotions.length > 0,
      promotions: 'promotions', // se usa en el mixin
    }),
    ...mapState('modals', {
      isAvailabilityModalOpen: (state) => state.availability.opened,
    }),
    ...mapState('availability', {
      item: (state) => {
        let items = []

        state.availability.ranges.forEach((range) => {
          range.items.forEach((t) => {
            t.availability
              .filter((t) => t.min_travelers === null || t.min_travelers === 1)
              .forEach((a) => items.push(a))
          })
        })

        items = items.sort((a, b) => b.price - a.price)

        return items.length > 0
          ? items[0]
          : {
              layaway: null,
              price: null,
              liquidate_before: null,
              datetime: { start: null, end: null },
            }
      },
    }),
    ...mapState('settings', ['currency']),
    amount() {
      return this.$options.filters.ladFnCurrency(
        this.item.layaway || this.layawayAmount,
        this.currency
      )
    },
    days() {
      if (!this.item.datetime || !this.item.datetime.start) return ''

      const format = 'YYYY-MM-DD'

      const liquidateBefore = this.$dayjs(
        this.item.datetime.start,
        format
      ).subtract(this.item.liquidate_before, 'day')

      const diff = parseInt(
        this.$dayjs(liquidateBefore).diff(this.$dayjs(), 'day', true) + 1
      )

      return diff
    },
    isFlairAirlinesSource() {
      return this.params.utm_source === 'flair'
    },
  },
  methods: {
    scrollTo() {
      const promise = this.isAvailabilityModalOpen
        ? this.$store.dispatch('modals/toggle', 'availability')
        : new Promise((resolve, reject) => resolve())

      promise.then(async () => {
        await this.$nuxt.$emit('close-bottom-drawer')

        this.$scrollTo('#lad-landing--form', this.delay, {
          offset: 5,
        })

        /** Sending event to Facebook */
        if (typeof this.$fb !== 'undefined') {
          this.$fb.trackCustom('click_more_info', {
            event_category: 'cta',
            event_label: `CTA with click_more_info`,
          })
        }

        /** Sending event to Google Analytics */
        if (typeof this.$gtag !== 'undefined') {
          this.$gtag('event', 'click_more_info', {
            event_category: 'cta',
            event_label: `CTA with click_more_info`,
            page_title: this.$metaInfo.title,
            page_location: window.location.href,
          })
        }
      })
    },
    goToFastCheckout() {
      // se comenta esta parte debido a que el CTA no esta mandando al carrito
      // no se elimina codigo, aun puede haber cambios y podria volver a necesitarse
      /*
        if (process.browser && typeof this.$gtag !== 'undefined') {
          const price = this.price - this.discountAmount

          this.$gtag('event', 'add_to_cart', {
            items: [
              {
                id: this.exExperience.uuid,
                name: this.exExperience.name,
                list_name: 'generic',
                brand: 'generic',
                category: 'product',
                variant: '',
                list_position: 1,
                quantity: '1',
                price: price === 0 ? '' : price.toFixed(2).toString(),
              },
            ],
          })

          this.$gtag('event', 'eec.addToCart', {
            ecommerce: {
              currencyCode: this.currency, // Currency (eg USD)
              add: {
                products: [
                  {
                    name: this.exExperience.name, // Product Name (eg Shirt1)
                    id: this.exExperience.uuid, // Product ID (eg 123)
                    price: price === 0 ? '' : price.toFixed(2).toString(),
                    quantity: '1', // Product Quantity (eg 1)
                  },
                ],
              },
            },
          })
        }
      */
      const promise = this.isAvailabilityModalOpen
        ? this.$store.dispatch('modals/toggle', 'availability')
        : new Promise((resolve, reject) => resolve())

      promise.then(() => {
        this.$store.dispatch('shopping-cart/setFastCheckout', {
          type: this.exExperience.type,
          item: {
            uuid: this.exExperience.uuid,
            qty: 1,
            unit: 1,
            parent: { uuid: null, index: null },
            departure_date: {
              open: true,
              start: null,
              end: null,
              code: null,
              language: this.language || this.item.language,
              season: this.season || this.item.season,
            },
          },
        })

        this.$router.push({
          name: 'checkout-layaway',
          params: {
            type: 'fast-checkout',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
.wrapper-availability-banner__custom {
  background-color: #e8ffe8;
  display: none;

  .lad-container-media-text {
    padding: 60px 0;
  }

  .el-main {
    padding: 0;
  }

  .container-with-icon {
    display: flex;
    gap: 5px;
    margin: 0;
    align-items: center;

    .percentage {
      &-icon {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #0a960c;
        border-radius: 6px;
        color: #fff;
        font-size: 14px;
        min-width: 24px;
      }

      &-text {
        color: #000;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 32.2px;
      }
    }
  }

  .lad-container-media-text--left {
    padding: 0;
    order: 1;
    text-align: left;
    max-width: 550px;
  }

  .lad-container-media-text--right {
    order: inherit;
    text-align: right;
  }

  .availability-banner {
    &--title {
      font-size: 2em;
      word-break: break-word;

      span {
        background-color: #3a7f18;
        color: white;
        padding: 3px 7px;
        border-radius: 2px;
      }
    }

    &--description {
      color: #007202;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 25.2px; /* 140% */
      margin: 15px 0;
    }
  }

  .reserve-with-cta {
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    padding: 15px 0;
    min-width: 350px;
  }

  .container-image-cover {
    position: relative;
    max-width: 240px;
    border-radius: 50%;
    margin: 0 50px 0 auto;

    .lad-image {
      &.image--cover {
        img {
          aspect-ratio: 1;
          border-radius: 50%;
        }
      }
    }
  }

  @media (min-width: 992px) {
    display: block;
  }
}
</style>
